import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';

import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.css'],
})
export class UploadModalComponent implements OnInit {
  filename: any;
  base64File: any;
  mapId: any;
  uploadFileData: any;
  uploadFile: any;
  formData: any;
  uploadError: any;
  error: any;
  errorMessage: any;
  errorFileName: any;
  close: any = false;
  json: any;
  annotation_upload ={}
  constructor(
    private dialogRef: MatDialogRef<UploadModalComponent>,
    private mapService: MapServiceService,
    private globalService: GlobalService,
    public sideNavService: SideNavService,
    private http: HttpClient
  ) {
    //
  }

  ngOnInit(): void {

    this.annotation_upload = this.mapService.getAllModals.annotation_upload
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
  }
  // onKmlChooseBtn() {

  // }

  onKmlUploadChange(e: any) {
    try {
      this.uploadFile = e.target.files[0];

      // console.log(this.formData);
      const fReader = new FileReader();
      fReader.readAsDataURL(this.uploadFile);
      fReader.onloadend = (event: any) => {
        this.filename = this.uploadFile.name;
        // console.log(this.filename);
        this.base64File = event.target.result;
        // console.log(this.base64File);
      };
    } catch (error) {
      this.filename = null;
      this.base64File = null;
      // console.log('no file was selected...');
    }
  }
  onKmlUpload() {
    // console.log(this.uploadFile)d
    this.formData = new FormData();
    this.formData.append('map_id', this.mapId);
    this.formData.append('file', this.uploadFile);
    this.formData.append('annotation_color', this.mapService.selectedColor);
    this.mapService.uploadAnnotationFile(this.formData).subscribe(
      (res) => {
        this.globalService.toggleLoader(true);
        this.mapService.uploadFileData = res;
        this.sideNavService.uploadAnnotationAfter(
          this.mapService.uploadFileData.uploaded_annotation_detail
        );
        this.uploadError = res;
        this.globalService.toggleLoader(false);
        this.close = true;
        this.dialogRef.close();
        this.sideNavService.clearUploadClassNow(true);
        this.activityLoging(`Annotation:Upload`);
      },
      (err) => {
        this.error = true;
        this.errorMessage = err.error.error;
        this.errorFileName = err.error.filename;
      }
    );
  }
  onKmlClose() {
    this.filename = '';
    this.close = true;
    this.dialogRef.close();
    this.sideNavService.clearUploadClassNow(true);
  }

  activityLoging(state: any) {
    this.json = JSON.stringify({
      'annotation_upload_name': `${this.filename}`,
    }),
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapService.mapId.toString(),
          event: 'Click',
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: state,
          event_information: this.json,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          point: '',
          wkt: '',
        };
        this.mapService.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }
}
